import { render } from "./p-introduce.vue?vue&type=template&id=70cd8079&scoped=true"
import script from "./p-introduce.vue?vue&type=script&lang=js"
export * from "./p-introduce.vue?vue&type=script&lang=js"

import "./p-introduce.vue?vue&type=style&index=0&id=70cd8079&lang=scss&scoped=true"

import exportComponent from "/root/workspace/__flow_work/__flow_builds/d72e10b2-82a4-4871-b4ef-3f0bf96be7c1/workspace/site-h5_3HZM/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70cd8079"]])

export default __exports__